
const DonorDemographicsList = ({ sampleRequestDemographics = [], raceList = [] }) => {
  return (
    <div>
      <p className="el-request-detail-profile-title">
        Donor Groups by Demographics:
      </p>

      <div className="el-request-detail-profile-name">
        <div className="d-flex flex-column gap-2">
          {sampleRequestDemographics.map((item, index) => {
            const raceIds = item.race_options ? JSON.parse(item.race_options) : [];
            const allRaceList = raceList.flatMap(group => group.race_options);

            const raceNames =
              raceIds.length > 0
                ? allRaceList
                    .filter(r => raceIds.includes(r.race_id))
                    .map(r => r.heritage_name)
                    .join(', ')
                : '';

            const serial = String.fromCharCode(97 + index); // 97 = 'a'

            const parts = [];
            if (item.demographics_quantity)
              parts.push(item.demographics_quantity);
            if (item.from_age && item.to_age)
              parts.push(`${item.from_age}-${item.to_age}`);
            if (item.demographics_gender) {
              const genderText = item.demographics_gender === 'XX' ? 'Female' : 'Male';
              parts.push(`${genderText} (${item.demographics_gender})`);
            }
            if (raceNames) parts.push(raceNames);

            return (
              <div key={item.id} className="d-flex gap-2">
                <span>{serial}.</span>
                <span>{parts.join(', ')}</span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default DonorDemographicsList;